import { ROUTES } from '@/features/core/container';
import { option } from '@/util/container';
import { component } from '../component';
import { APP_CUSTOMER } from './app.builder';

export default option(ROUTES, async () => {
  return [
    {
      path: '/customer/:customerId/vendor-apis/gk40-heizungsprofi/:vendorApiId',
      component: component('views/gk40-heizungsprofi/GK40HeizungsprofiConfigurationView.vue'),
      props: true,
      meta: { app: APP_CUSTOMER, key: (): string => `AppCustomer/VendorApis/GK40Heizungsprofi` },
      children: [
        {
          path: '/customer/:customerId/vendor-apis/gk40-heizungsprofi/:vendorApiId',
          name: 'AppCustomer/VendorApis/GK40Heizungsprofi',
          meta: { app: APP_CUSTOMER },
          beforeEnter: ({ params }, from, next) =>
            void next({ name: 'AppCustomer/VendorApis/GK40Heizungsprofi/Settings', params }),
        },
        {
          path: 'settings',
          name: 'AppCustomer/VendorApis/GK40Heizungsprofi/Settings',
          component: component('views/gk40-heizungsprofi/settings/SettingsView.vue'),
          props: true,
          meta: { app: APP_CUSTOMER },
        },
      ],
    },
  ];
});
